"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_263wce3hlx = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/Tree.js";
  var hash = "b89ce9b8b00cb0c17ef43995ef166a10cd9b14b3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/Tree.js",
    statementMap: {
      "0": {
        start: {
          line: 28,
          column: 27
        },
        end: {
          line: 28,
          column: 47
        }
      },
      "1": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 32,
          column: 3
        }
      },
      "2": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 56
        }
      },
      "3": {
        start: {
          line: 33,
          column: 42
        },
        end: {
          line: 33,
          column: 65
        }
      },
      "4": {
        start: {
          line: 35,
          column: 21
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "5": {
        start: {
          line: 36,
          column: 19
        },
        end: {
          line: 36,
          column: 51
        }
      },
      "6": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 20
        }
      },
      "7": {
        start: {
          line: 40,
          column: 21
        },
        end: {
          line: 40,
          column: 49
        }
      },
      "8": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "9": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 17
        }
      },
      "10": {
        start: {
          line: 45,
          column: 19
        },
        end: {
          line: 45,
          column: 21
        }
      },
      "11": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 81,
          column: 3
        }
      },
      "12": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 80,
          column: 7
        }
      },
      "13": {
        start: {
          line: 48,
          column: 25
        },
        end: {
          line: 48,
          column: 53
        }
      },
      "14": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 70,
          column: 7
        }
      },
      "15": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 59,
          column: 10
        }
      },
      "16": {
        start: {
          line: 60,
          column: 13
        },
        end: {
          line: 70,
          column: 7
        }
      },
      "17": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 69,
          column: 10
        }
      },
      "18": {
        start: {
          line: 71,
          column: 29
        },
        end: {
          line: 71,
          column: 63
        }
      },
      "19": {
        start: {
          line: 71,
          column: 35
        },
        end: {
          line: 71,
          column: 63
        }
      },
      "20": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 79,
          column: 8
        }
      },
      "21": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 89,
          column: 4
        }
      },
      "22": {
        start: {
          line: 92,
          column: 0
        },
        end: {
          line: 114,
          column: 1
        }
      },
      "23": {
        start: {
          line: 116,
          column: 0
        },
        end: {
          line: 119,
          column: 1
        }
      },
      "24": {
        start: {
          line: 121,
          column: 15
        },
        end: {
          line: 126,
          column: 2
        }
      },
      "25": {
        start: {
          line: 121,
          column: 25
        },
        end: {
          line: 126,
          column: 1
        }
      },
      "26": {
        start: {
          line: 128,
          column: 20
        },
        end: {
          line: 128,
          column: 53
        }
      }
    },
    fnMap: {
      "0": {
        name: "TreeComponent",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 22
          }
        },
        loc: {
          start: {
            line: 27,
            column: 3
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 27
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 35,
            column: 22
          }
        },
        loc: {
          start: {
            line: 35,
            column: 33
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 35
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 47,
            column: 27
          },
          end: {
            line: 47,
            column: 28
          }
        },
        loc: {
          start: {
            line: 47,
            column: 46
          },
          end: {
            line: 80,
            column: 5
          }
        },
        line: 47
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 71,
            column: 29
          },
          end: {
            line: 71,
            column: 30
          }
        },
        loc: {
          start: {
            line: 71,
            column: 35
          },
          end: {
            line: 71,
            column: 63
          }
        },
        line: 71
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 121,
            column: 15
          },
          end: {
            line: 121,
            column: 16
          }
        },
        loc: {
          start: {
            line: 121,
            column: 25
          },
          end: {
            line: 126,
            column: 1
          }
        },
        line: 121
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 36
          },
          end: {
            line: 28,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 36
          },
          end: {
            line: 28,
            column: 40
          }
        }, {
          start: {
            line: 28,
            column: 44
          },
          end: {
            line: 28,
            column: 46
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        }, {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        }],
        line: 30
      },
      "2": {
        loc: {
          start: {
            line: 40,
            column: 21
          },
          end: {
            line: 40,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 21
          },
          end: {
            line: 40,
            column: 27
          }
        }, {
          start: {
            line: 40,
            column: 31
          },
          end: {
            line: 40,
            column: 49
          }
        }],
        line: 40
      },
      "3": {
        loc: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 41
      },
      "4": {
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 14
          }
        }, {
          start: {
            line: 41,
            column: 18
          },
          end: {
            line: 41,
            column: 27
          }
        }],
        line: 41
      },
      "5": {
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        }, {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        }],
        line: 46
      },
      "6": {
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 70,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 70,
            column: 7
          }
        }, {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 70,
            column: 7
          }
        }],
        line: 50
      },
      "7": {
        loc: {
          start: {
            line: 60,
            column: 13
          },
          end: {
            line: 70,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 13
          },
          end: {
            line: 70,
            column: 7
          }
        }, {
          start: {
            line: 60,
            column: 13
          },
          end: {
            line: 70,
            column: 7
          }
        }],
        line: 60
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "b89ce9b8b00cb0c17ef43995ef166a10cd9b14b3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tree = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _BlobObject = require("./BlobObject");

var _TreeObject = require("./TreeObject");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/**
 * A Listing Component to render an array of Git Tree objects.
 */


function TreeComponent(_ref) {
  var classes = _ref.classes,
      tree = _ref.tree,
      url = _ref.url,
      config = _ref.config,
      selected = _ref.selected,
      blob = _ref.blob,
      onBlob = _ref.onBlob,
      depth = _ref.depth,
      filepath = _ref.filepath;
  cov_263wce3hlx.f[0]++;

  var _ref2 = (cov_263wce3hlx.s[0]++, (0, _react.useState)((cov_263wce3hlx.b[0][0]++, tree) || (cov_263wce3hlx.b[0][1]++, []))),
      _ref3 = _slicedToArray(_ref2, 2),
      _tree = _ref3[0],
      setTree = _ref3[1];

  var _selectedPath;

  cov_263wce3hlx.s[1]++;

  if (blob) {
    cov_263wce3hlx.b[1][0]++;
    cov_263wce3hlx.s[2]++;
    _selectedPath = blob.filepath.split('/')[depth - 2];
  } else {
    cov_263wce3hlx.b[1][1]++;
  }

  var _ref4 = (cov_263wce3hlx.s[3]++, (0, _react.useState)(_selectedPath)),
      _ref5 = _slicedToArray(_ref4, 2),
      selectedPath = _ref5[0],
      setSelectedPath = _ref5[1];

  cov_263wce3hlx.s[4]++;

  var updateTree = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var __tree;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cov_263wce3hlx.f[1]++;
              cov_263wce3hlx.s[5]++;
              _context.next = 4;
              return (0, _helpers.fetchTree)({
                url: url,
                config: config
              });

            case 4:
              __tree = _context.sent;
              cov_263wce3hlx.s[6]++;
              setTree(__tree);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function updateTree() {
      return _ref6.apply(this, arguments);
    };
  }();

  var emptyTree = (cov_263wce3hlx.s[7]++, (cov_263wce3hlx.b[2][0]++, !_tree) || (cov_263wce3hlx.b[2][1]++, _tree.length === 0));
  cov_263wce3hlx.s[8]++;

  if ((cov_263wce3hlx.b[4][0]++, selected) && (cov_263wce3hlx.b[4][1]++, emptyTree)) {
    cov_263wce3hlx.b[3][0]++;
    cov_263wce3hlx.s[9]++;
    updateTree();
  } else {
    cov_263wce3hlx.b[3][1]++;
  }

  var components = (cov_263wce3hlx.s[10]++, []);
  cov_263wce3hlx.s[11]++;

  if (_tree) {
    cov_263wce3hlx.b[5][0]++;
    cov_263wce3hlx.s[12]++;
    components = _tree.map(function (object, index) {
      cov_263wce3hlx.f[2]++;

      var _selected = (cov_263wce3hlx.s[13]++, object.path === selectedPath);

      var component;
      cov_263wce3hlx.s[14]++;

      if (object.type === 'tree') {
        cov_263wce3hlx.b[6][0]++;
        cov_263wce3hlx.s[15]++;
        component = _react.default.createElement(_TreeObject.TreeObject, _extends({}, object, {
          selected: _selected,
          depth: depth,
          onBlob: onBlob,
          filepath: filepath
        }));
      } else {
        cov_263wce3hlx.b[6][1]++;
        cov_263wce3hlx.s[16]++;

        if (object.type === 'blob') {
          cov_263wce3hlx.b[7][0]++;
          cov_263wce3hlx.s[17]++;
          component = _react.default.createElement(_BlobObject.BlobObject, {
            blob: object,
            onBlob: onBlob,
            selected: _selected,
            depth: depth,
            filepath: filepath
          });
        } else {
          cov_263wce3hlx.b[7][1]++;
        }
      }

      cov_263wce3hlx.s[18]++;

      var onSelectedPath = function onSelectedPath() {
        cov_263wce3hlx.f[3]++;
        cov_263wce3hlx.s[19]++;
        return setSelectedPath(object.path);
      };

      cov_263wce3hlx.s[20]++;
      return _react.default.createElement("div", {
        key: index,
        onClick: onSelectedPath
      }, component);
    });
  } else {
    cov_263wce3hlx.b[5][1]++;
  }

  cov_263wce3hlx.s[21]++;
  return _react.default.createElement(_core.Collapse, {
    in: selected,
    timeout: "auto",
    unmountOnExit: true
  }, _react.default.createElement(_core.List, {
    "data-test": "file-tree",
    dense: true,
    className: classes.list
  }, components));
}

cov_263wce3hlx.s[22]++;
TreeComponent.propTypes = {
  /** @ignore */
  classes: _propTypes.default.object.isRequired,

  /** An array of paths from the Gitea file tree api. */
  tree: _propTypes.default.arrayOf(_propTypes.default.shape({
    path: _propTypes.default.string.isRequired,
    type: _propTypes.default.oneOf(['tree', 'blob']).isRequired
  })),

  /** The Url to fetch the listing if listing is not provided. */
  url: _propTypes.default.string,

  /** If url is relative, pass the server in the config object. */
  config: _propTypes.default.shape({
    server: _propTypes.default.string
  }),

  /** Set if the Listing is currently selected, which will expand the collapsed view. */
  selected: _propTypes.default.bool,

  /** Function to propogate when the Blob is selected. */
  onBlob: _propTypes.default.func,

  /** The depth of the path in the tree sets the inset of the component. */
  depth: _propTypes.default.number,

  /** The nested filepath that will concatenate. */
  filepath: _propTypes.default.string
};
cov_263wce3hlx.s[23]++;
TreeComponent.defaultProps = {
  selected: false,
  depth: 1
};
cov_263wce3hlx.s[24]++;

var styles = function styles(theme) {
  cov_263wce3hlx.f[4]++;
  cov_263wce3hlx.s[25]++;
  return {
    list: {
      paddingTop: 0,
      paddingBottom: 0
    }
  };
};

var Tree = (cov_263wce3hlx.s[26]++, (0, _styles.withStyles)(styles)(TreeComponent));
exports.Tree = Tree;